export const EventAddClick: string = 'EventAddClick';
export const EventEditClick: string = 'EventEditClick';
export const EventRemoveClick: string = 'EventRemoveClick';
